import Vue from 'vue';
import querystring from 'querystring';
import * as Preguntas from '@lib/MercadoLibre/Preguntas';
import { Pregunta } from '@lib/MercadoLibre/Preguntas';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Controlador as Responder } from '@com/preguntas-contestar/preguntas-responder-controlador';
import { SimpleEventDispatcher, SignalDispatcher } from 'strongly-typed-events';
import { Utiles } from '@/__env/pluggins/event-bus';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';


export class ControladorDePreguntas extends Vue
{

    public Buscador: Buscador = new Buscador();

}

export class Buscador extends Vue
{
    async NuevaPregunta( x: number )
    {
        let e = await Pregunta.create( x );
        if ( e && e.Estado == Preguntas.Estados.NoRespondida )
            this._onNuevaPregunta.dispatch( e );
    }
    Iniciar()
    {
        if ( !this.Iniciado )
        {
            Utiles.$socket.client.on( 'nueva-pregunta-ml', ( x: any ) => this.NuevaPregunta( x.id ) );
            this.Iniciado = true;
        }
    }
    protected Iniciado: boolean = false;
    public Items: Pregunta[] = [];
    public Filtros: Filtros = new Filtros( this );
    public Estado: 'cargando' | 'vacio' | 'ok' | 'error' = 'cargando';
    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Filtros.Valores.Pagina = pagina;

        this.Items.clear();
        this.Estado = 'cargando';

        this._onActualizar.dispatch();


        await Wait( 100 );
        let e = await Pregunta.find( this.Filtros.Obtener() );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }

    private _onActualizar: SignalDispatcher = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    private _onNuevaPregunta = new SimpleEventDispatcher<Pregunta>();
    public get onNuevaPregunta() { return this._onNuevaPregunta.asEvent(); }
}

export class Filtros
{
    constructor( b: Buscador )
    {
        this.Buscador = b;
    }

    public Buscador: Buscador;
    public Busqueda: string = '';

    public Valores: Record<string, number> = {
        Estado: 2,
        Limite: 1,
        Orden: 0,
        Indice: 0,
        Cuenta: 0,
        Pagina: 1,
    };

    public get Estados() { return Preguntas.Estados.Filter; }
    public get Cuentas() { return [...CuentasMercadoLibre]; }
    public get Limites() { return [{ Nombre: '5', Id: 5 }, { Nombre: '10', Id: 10 }, { Nombre: '20', Id: 20 }, { Nombre: '50', Id: 50 }]; }
    public get Ordenes() { return [{ Nombre: 'Descendente', Id: 'DESC' }, { Nombre: 'Ascendente', Id: 'ASC' }]; }
    public get Indices()
    {
        return [
            { Nombre: 'Fecha creación', Id: 'fecha' },
            { Nombre: 'Id', Id: 'id' },
            { Nombre: 'Usuario', Id: 'usuario_nickname' },
            { Nombre: 'Publicación', Id: 'publicacion' },
        ];
    }


    public get Activos(): { Nombre: string, Eliminar: any; }[]
    {

        let a: { Nombre: string, Eliminar: any; }[] = [];

        if ( this.Busqueda )
        {
            a.push( { Nombre: `Resultados para: ${this.Busqueda}`, Eliminar: () => { this.Busqueda = ''; this.Buscador.Buscar(); } } );
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                a.push( { Nombre: this.Estados[this.Valores.Estado].Nombre, Eliminar: () => { this.Valores.Estado = 0; this.Buscador.Buscar(); } } );
            }

            if ( this.Valores.Cuenta > 0 )
            {
                a.push( { Nombre: this.Cuentas[this.Valores.Cuenta].Nombre, Eliminar: () => { this.Valores.Cuenta = 0; this.Buscador.Buscar(); } } );
            }


        }

        return a;
    }

    public Obtener(): any
    {
        let filtro: any = {};




        if ( this.Valores.Cuenta > 0 )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }

        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }
        else
        {

            if ( this.Valores.Estado > 0 )
            {
                filtro.estado = this.Estados[this.Valores.Estado].Valor.map( x => x.Id ).join( ',' );
            }


        }

        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }

        return filtro;
    }

    public set( filtro: any )
    {

        if ( filtro.q )
        {
            this.Busqueda = String( filtro.q );
        }

        if ( filtro.estado )
        {
            this.Valores.Estado = 0;
            let idx = this.Estados.findIndex( x => x.Nombre.eliminar( ' ' ).toLowerCase() == filtro.estado );
            if ( idx > 0 ) this.Valores.Estado = idx;
        }

        if ( filtro.cuenta )
        {
            this.Valores.Cuenta = 0;
            let idx = this.Cuentas.findIndex( x => x.Id == filtro.cuenta );
            if ( idx > 0 ) this.Valores.Cuenta = idx;
        }


        if ( filtro.limit )
        {
            this.Valores.Limite = 1;
            let idx = this.Limites.findIndex( x => x.Id == filtro.limit );
            if ( idx > 0 ) this.Valores.Limite = idx;
        }

        if ( filtro.sort )
        {
            this.Valores.Orden = 0;
            let idx = this.Ordenes.findIndex( x => x.Id == filtro.sort );
            if ( idx > 0 ) this.Valores.Orden = idx;
        }

        if ( filtro.order )
        {
            this.Valores.Indice = 0;
            let idx = this.Indices.findIndex( x => x.Id == filtro.order );
            if ( idx > 0 ) this.Valores.Indice = idx;
        }

        if ( filtro.page > 0 )
        {
            this.Valores.Pagina = filtro.page;
        }

    }

    public get(): string
    {
        let filtro: any = {};
        if ( this.Busqueda )
        {
            filtro.q = this.Busqueda;
        }

        if ( this.Valores.Estado > 0 )
        {
            filtro.estado = this.Estados[this.Valores.Estado].Nombre.eliminar( ' ' ).toLowerCase();
        }

        if ( this.Valores.Cuenta )
        {
            filtro.cuenta = this.Cuentas[this.Valores.Cuenta].Id;
        }


        if ( this.Valores.Limite >= 0 )
        {
            filtro.limit = this.Limites[this.Valores.Limite].Id;
        }

        if ( this.Valores.Orden >= 0 )
        {
            filtro.sort = this.Ordenes[this.Valores.Orden].Id;
        }

        if ( this.Valores.Indice >= 0 )
        {
            filtro.order = this.Indices[this.Valores.Indice].Id;
        }

        if ( this.Valores.Pagina > 0 )
        {
            filtro.page = this.Valores.Pagina;
        }


        return querystring.encode( filtro );
    }
}

const Controlador = new ControladorDePreguntas();
export { Controlador };

